<template>
  <span>
    <span v-for="(item, index) in value" :key="item._id">
      {{index > 0?separation: ''}}{{item[labelField] || item}}
    </span>
  </span>
</template>

<script>
  export default {
    name: "dol-array-join",
    props: {
      value:{type: Array, default: () => []},
      separation:{type: String, default: ' / '},
      labelField:{type: String, default: 'name'},
    }
  }
</script>

<style lang="scss" scoped>

</style>
